import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { FormCard, FormGrid } from "../FormCard";
import { DetailRow, SelectRow } from "../Rows";
import { GetDiagnosticsContent } from "../diagnostics/GetDiagnosticsModal";
import ConfirmationModal from "../ConfirmationModal";
import { isOcpp201 } from "./ocppPointHelpers";

const TRIGGER_MESSAGES_16 = [
  "BootNotification",
  "DiagnosticsStatusNotification",
  "FirmwareStatusNotification",
  "Heartbeat",
  "MeterValues",
  "StatusNotification",
  "StartTransaction",
  "StopTransaction",
];

const TRIGGER_MESSAGES_201 = [
  "BootNotification",
  "LogStatusNotification",
  "FirmwareStatusNotification",
  "Heartbeat",
  "MeterValues",
  "StatusNotification",
  "TransactionEvent",
  "PublishFirmwareStatusNotification",
];

const toTriggerOptions = (messages) =>
  messages.map((message) => ({
    value: message,
    label: message,
  }));

const RemoteManagement = ({
  chargingPoint,
  resetPoint,
  clearCache,
  triggerMessage,
  handleInputChange,
}) => {
  const { t } = useTranslation();
  const [confirmRestartOpen, setConfirmRestartOpen] = useState(false);
  const disabled = chargingPoint?.isOnline === false;
  const is201 = isOcpp201(chargingPoint?.ocppVersion);
  const triggerMessages = toTriggerOptions(
    is201 ? TRIGGER_MESSAGES_201 : TRIGGER_MESSAGES_16
  );
  const clearCacheDisabled = disabled || is201;

  return (
    <>
    <div className="mt-4">
      <FormGrid className="gap-6">
        <FormCard title={t("common.commands")} bodyClassName="flex flex-col gap-6">
          <DetailRow
            label={t("common.status")}
            value={disabled ? t("remote.offline") : t("remote.ready")}
          />
          <div className="flex justify-end gap-2">
            <button
              className="btn btn-primary"
              onClick={() => {
                if (!disabled) {
                  setConfirmRestartOpen(true);
                }
              }}
              disabled={disabled}
            >
              {t("common.restart")}
            </button>
            <button
              className="btn btn-primary"
              onClick={() => {
                if (!clearCacheDisabled) {
                  clearCache();
                }
              }}
              disabled={clearCacheDisabled}
              title={is201 ? t("remote.clearCacheUnavailable") : undefined}
            >
              {t("common.clearCache")}
            </button>
          </div>
            <SelectRow
                label={t("common.message")}
                options={triggerMessages}
                value={chargingPoint.triggerMessage}
                onChange={(value) => {
                    if (!disabled) {
                        handleInputChange("triggerMessage", value);
                    }
                }}
                disabled={disabled}
            />

            <div className="flex justify-end">
                <button
                    className="btn btn-primary"
                    onClick={() => {
                        if (!disabled) {
                            triggerMessage();
                        }
                    }}
                    disabled={disabled}
                >
                    {t("remote.sendMessage")}
                </button>
            </div>
        </FormCard>

        <FormCard
          title={t("remote.getDiagnostics")}
          bodyClassName="flex flex-col gap-6"
          className="md:col-span-2"
        >

          <GetDiagnosticsContent
            chargingPointPublicId={chargingPoint?.chargingPointPublicId}
            chargingPointName={chargingPoint?.chargingPointName}
            ocppVersion={chargingPoint?.ocppVersion}
            disabled={disabled}
            supportsGetDiagnostics={
              chargingPoint?.supportsGetDiagnostics ?? true
            }
          />
        </FormCard>

      </FormGrid>
    </div>
      <ConfirmationModal
        isOpen={confirmRestartOpen}
        title={t("remote.restartCharger")}
        onClose={() => setConfirmRestartOpen(false)}
        onConfirm={() => {
          setConfirmRestartOpen(false);
          resetPoint();
        }}
      />
    </>
  );
};

export default RemoteManagement;
